import { render, staticRenderFns } from "./NeedsList.vue?vue&type=template&id=015067e5&scoped=true"
import script from "./NeedsList.vue?vue&type=script&lang=js"
export * from "./NeedsList.vue?vue&type=script&lang=js"
import style0 from "./NeedsList.vue?vue&type=style&index=0&id=015067e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015067e5",
  null
  
)

export default component.exports